module.exports = "/fonts/Gineso-Norm-Regular.ttf";